<script lang="ts">
	import cn from 'classnames';
	import { _SortingEnum } from '$lib/utils/Enums';
	import { browser } from '$app/environment';
	import { goto } from '$app/navigation';
	import {createEventDispatcher} from "svelte";
	export let sorting = _SortingEnum.recommended.toString();
	export let count = 0;
	export let type: 'blog' | 'default' = 'default';
	// bindable props like products
	export let products: any;
	let data: any;

	const dispatch = createEventDispatcher();
	async function handleSortChange() {
		dispatch('sortChange', { products });
	} 

	const productItems: Array<{ text: string; code: string }> = [
		{ text: 'Doporučujeme', code: _SortingEnum.recommended.toString() },
		{ text: 'Název', code: _SortingEnum.name.toString() },
		{ text: 'Nejrychlejší dodání', code: _SortingEnum.avail.toString() },
		{ text: 'Nejlevnější', code: _SortingEnum.price.toString() }
	];

	const blogListItems: Array<{ text: string; code: string }> = [
		{ text: 'Nejnovější', code: 'latest' },
		{ text: 'Nejoblíbenější', code: 'favourites' },
		{ text: 'Nejstarší', code: 'oldest' }
	];

	if (type === 'blog') {
		data = blogListItems;
	} else {
		data = productItems;
	}
	
	// get sorting from url
	if (browser) {
		const urlParams = new URLSearchParams(window.location.search);
		const sortingFromUrl = urlParams.get('sorting');
		if (sortingFromUrl) {
			sorting = sortingFromUrl;
			// sort
			changeSorting(sorting);
		}
	}

	//todo: Type
	data.forEach((item: any) => {
		if (browser) {
			let isSortingInUrl = window.location.href.includes('sorting');
			item.url = isSortingInUrl
				? window.location.href.replace(/sorting=[^&]+/, `sorting=${item.code}`)
				: window.location.href.includes('?')
					? `${window.location.href}&sorting=${item.code}`
					: `${window.location.href}?sorting=${item.code}`;
		}
	});
	
	
	export async function changeSortingByPrice() {
		console.log("price")
		console.log(products.data)
		products.data.sort((a:any, b:any) => {
			if (a.price < b.price) return -1;
			if (a.price > b.price) return 1;
			return 0;
		});
		products = { ...products };
		// set "?sorting=price" to url
		await goto(`${window.location.pathname}?sorting=price`, { replaceState: true });
		sorting = _SortingEnum.price.toString();
		await handleSortChange();
	}
	// Sorting by recommended -> product.action == "R"
	// then by name
	export async function changeSortingByRecommended() {
		products.data.sort((a, b) => {
			if (a.action === 'R' && b.action !== 'R') return -1;
			if (a.action !== 'R' && b.action === 'R') return 1;
			if (a.action === 'R' && b.action === 'R') {
				if (a.name < b.name) return -1;
				if (a.name > b.name) return 1;
			}
			return 0;
		});
		await goto(`${window.location.pathname}?sorting=recommended`, { replaceState: true });
		sorting = _SortingEnum.recommended.toString();
		products = { ...products };
		await handleSortChange();
	}
	
	// sort by avail and price
	export async function changeSortingByAvail() {
		products.data.sort((a, b) => {
			const availabilityOrder = [
				"skladem",        // 1. místo
				"u dodavatele",   // 2. místo
				"na objednávku",  // 3. místo
				"na dotaz",       // 4. místo
				"nedostupné"      // 5. místo
			];

			// Funkce, která zjistí pořadí na základě klíčových slov na začátku řetězce
			const getAvailabilityOrder = (location: any) => {
				for (let i = 0; i < availabilityOrder.length; i++) {
					if (location.startsWith(availabilityOrder[i])) {
						return i; // vrací pořadí v rámci pole availabilityOrder
					}
				}
				return availabilityOrder.length; // pokud neobsahuje žádnou známou hodnotu, vrací poslední místo
			};

			// Zjisti pořadí podle dostupnosti pro oba produkty
			const aOrder = getAvailabilityOrder(a.availability_location);
			const bOrder = getAvailabilityOrder(b.availability_location);

			return aOrder - bOrder;
		});
		
		await goto(`${window.location.pathname}?sorting=avail`, { replaceState: true });
		sorting = _SortingEnum.avail.toString();
		products = { ...products };
		await handleSortChange();

	};
	
	export async function changeSortingByName() {
		console.log(products)
		products.data.sort((a, b) => {
			if (a.name < b.name) return -1;
			if (a.name > b.name) return 1;
			return 0;
		});
		products = { ...products };
		await goto(`${window.location.pathname}?sorting=name`, { replaceState: true });
		sorting = _SortingEnum.name.toString();
		await handleSortChange();
	}

	async function changeSorting(sorting: string) {
		// switch
		switch (sorting) {
			case _SortingEnum.recommended.toString():
				sorting = _SortingEnum.recommended.toString();
				await changeSortingByRecommended();
				break;
			case _SortingEnum.name.toString():
				sorting = _SortingEnum.name.toString();
				await changeSortingByName();
				break;
			case _SortingEnum.avail.toString():
				sorting = _SortingEnum.avail.toString();
				await changeSortingByAvail();
				break;
			case _SortingEnum.price.toString():
				sorting = _SortingEnum.price.toString();
				await changeSortingByPrice();
				break;
			default:
				sorting = _SortingEnum.recommended.toString();
				await changeSortingByRecommended();
				break;

		}
	}
</script>

{#if data && data.length > 0}
	<div
		id="sortingElement"
		class={cn(
			'mx-auto mt-4 flex w-full flex-row justify-between border-gray-concrete md:border-b-3 lg:mt-7',
			$$props.class
		)}
	>
		<ul class="hidden h-10 translate-y-[3px] list-none flex-row gap-x-4 sm:flex md:gap-x-9">
			{#if data?.length > 0}
				{#each data as item}
					<li class="h-full">
						<div
							on:click={() => changeSorting(item.code)}
							data-sveltekit-preload-data="tap"
							class={cn(
								'block h-10 grow whitespace-nowrap border-gray-concrete pb-3 transition-colors md:border-b-3',
								sorting === item.code
									? 'border-yellow font-bold'
									: 'underline hover:border-yellow md:no-underline'
							)}
						>
							{item.text}
						</div>
					</li>
				{/each}
			{/if}
		</ul>

		<select class="bg-gray-concrete px-2.5 py-1 sm:hidden"
			>{#each data as item}
				<option>
					{item.text}
				</option>
			{/each}</select
		>

		{#if count && type === 'default'}
			<div class="hidden h-10 translate-y-[3px] text-gray-oslogray md:flex">
				{count} produktů
			</div>
		{/if}
	</div>
{/if}
